import React from 'react';

import Login from './Login';

// Importando CSS
import '../../styles/global.css';
// import './style.css';


function Admin() {

    return (
        <Login />
    );
}

export default Admin;